// extracted by mini-css-extract-plugin
export default {"slotHighlighted":"IxwVZ_"};